// API Configuration
const getApiBaseUrl = (): string => {
    // Use environment variable if available, otherwise fall back to localhost for development
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';

    // Log API URL for debugging (only in development)
    if (process.env.NODE_ENV === 'development') {
        console.log('API Base URL:', apiUrl);
        console.log('Environment variables:', {
            REACT_APP_API_URL: process.env.REACT_APP_API_URL,
            NODE_ENV: process.env.NODE_ENV
        });
    }

    return apiUrl;
};

export const API_BASE_URL = getApiBaseUrl();

// Add a health check function
export const checkApiHealth = async (): Promise<boolean> => {
    try {
        const response = await fetch(`${API_BASE_URL}/health`);
        const data = await response.json();
        console.log('API Health Check:', data);
        return response.ok;
    } catch (error) {
        console.error('API Health Check Failed:', error);
        return false;
    }
};

export const apiEndpoints = {
    parseFreight: `${API_BASE_URL}/parse-freight`,
    userRole: `${API_BASE_URL}/user/role`,
    adminUsers: `${API_BASE_URL}/admin/users`,
    adminAccounts: `${API_BASE_URL}/admin/accounts`,
    upload: `${API_BASE_URL}/upload`,
    results: (jobId: string) => `${API_BASE_URL}/results/${jobId}`,
    gmailAuth: (userId: string, accountId: string) => `${API_BASE_URL}/gmailauth?userid=${userId}&accountid=${accountId}`,
    accountIntegrations: (accountId: string, userId: string) => `${API_BASE_URL}/accounts/${accountId}/integrations?userId=${userId}`,
    disconnectIntegration: (accountId: string, integrationId: string) => `${API_BASE_URL}/accounts/${accountId}/integrations/${integrationId}`,
    getSignedUrl: (filename: string) => `${API_BASE_URL}/api/get-signed-url/${filename}`, // Fixed to use full API URL
    health: `${API_BASE_URL}/health`,
    corsTest: `${API_BASE_URL}/cors-test`,
} as const; 